import { useFormContext, useFormState } from "react-hook-form";
import FormCheckbox from "../../shared/FormCheckbox";
import FormInputText from "../../shared/FormInputText";
import FormSelect from "../../shared/FormSelect";
import { SUB_ACCOUNT_DRAFT, USA_STATES } from "../../../utils/constants";

const step = 2;
const SubAccountStepTwo = ({ activeStep }) => {
    const { control, register, setValue, getValues, resetField, trigger } = useFormContext();
    const { errors } = useFormState({ control });

    if (activeStep !== step) return null;

    const parentAccountId = getValues(`${SUB_ACCOUNT_DRAFT}.parentAccount`)?.key;

    const onSelectedCheckbox = async (checked) => {
        if (checked && parentAccountId) {
            const topAccount = getValues();
            const subAccounts = topAccount.subAccounts ?? [];
            const parentAccount = [topAccount, ...subAccounts].find(a => a.accountId === parentAccountId);

            setValue(`${SUB_ACCOUNT_DRAFT}.ignorePrimaryAddressCheck`, parentAccount.ignorePrimaryAddressCheck);
            setValue(`${SUB_ACCOUNT_DRAFT}.primaryAddress1`, parentAccount.primaryAddress1 ?? '', { shouldValidate: true });
            setValue(`${SUB_ACCOUNT_DRAFT}.primaryAddress2`, parentAccount.primaryAddress2 ?? '');
            setValue(`${SUB_ACCOUNT_DRAFT}.primaryAddress3`, parentAccount.primaryAddress3 ?? '');
            setValue(`${SUB_ACCOUNT_DRAFT}.primaryAddressCity`, parentAccount.primaryAddressCity ?? '', { shouldValidate: true });
            setValue(`${SUB_ACCOUNT_DRAFT}.primaryAddressState`, parentAccount.primaryAddressState, { shouldValidate: true });
            setValue(`${SUB_ACCOUNT_DRAFT}.primaryAddressZip`, parentAccount.primaryAddressZip ?? '', { shouldValidate: true });
        } else {
            resetField(`${SUB_ACCOUNT_DRAFT}.ignorePrimaryAddressCheck`);
            resetField(`${SUB_ACCOUNT_DRAFT}.primaryAddress1`);
            resetField(`${SUB_ACCOUNT_DRAFT}.primaryAddress2`);
            resetField(`${SUB_ACCOUNT_DRAFT}.primaryAddress3`);
            resetField(`${SUB_ACCOUNT_DRAFT}.primaryAddressCity`);
            resetField(`${SUB_ACCOUNT_DRAFT}.primaryAddressState`);
            resetField(`${SUB_ACCOUNT_DRAFT}.primaryAddressZip`);

            await trigger([
                `${SUB_ACCOUNT_DRAFT}.primaryAddress1`,
                `${SUB_ACCOUNT_DRAFT}.primaryAddressCity`,
                `${SUB_ACCOUNT_DRAFT}.primaryAddressState`,
                `${SUB_ACCOUNT_DRAFT}.primaryAddressZip`
            ]);
        }
    }

    return (
        <div style={{ width: "50%" }}>
            <FormCheckbox
                label={'Copy Parent Primary Correspondence Address'}
                name={`${SUB_ACCOUNT_DRAFT}.copyParentPrimaryCorrespondence`}
                control={control}
                disabled={!parentAccountId}
                onSelectedHandler={onSelectedCheckbox}
            />
            <br />
            <FormCheckbox
                label={'Ignore Address Check'}
                name={`${SUB_ACCOUNT_DRAFT}.ignorePrimaryAddressCheck`}
                control={control}
            />
            <br />
            <FormInputText label={'Primary Correspondence - Address Line 1'} register={register} name={`${SUB_ACCOUNT_DRAFT}.primaryAddress1`} errors={errors} placeholder="Address" />
            <FormInputText label={'Primary Correspondence - Address Line 2'} register={register} name={`${SUB_ACCOUNT_DRAFT}.primaryAddress2`} errors={errors} placeholder="Address (optional)" />
            <FormInputText label={'Primary Correspondence - Address Line 3'} register={register} name={`${SUB_ACCOUNT_DRAFT}.primaryAddress3`} errors={errors} placeholder="Address (optional)" />
            <FormInputText label={'Primary Correspondence - Address City'} register={register} name={`${SUB_ACCOUNT_DRAFT}.primaryAddressCity`} errors={errors} placeholder="City" />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '2rem' }}>
                <FormSelect
                    label={'Primary Correspondence - Address State'}
                    name={`${SUB_ACCOUNT_DRAFT}.primaryAddressState`}
                    control={control}
                    options={USA_STATES}
                    errors={errors}
                    placeholder="Select a state"
                />
                <FormInputText label={'Primary Correspondence - Address Zip'} register={register} name={`${SUB_ACCOUNT_DRAFT}.primaryAddressZip`} errors={errors} placeholder="Zip code" />
            </div>
        </div>
    );
};

export default SubAccountStepTwo;
